import { CanDeactivateFn, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';

import { Need4SteelWizardService } from '../services/need4steel-wizard.service';
import { WizardComponent } from '../components/wizard/wizard.component';
import { MillOfferService } from '../services/mill-offer.service';

export const need4SteelWizardExitGuard: CanDeactivateFn<WizardComponent> = (
	_component: WizardComponent,
	_currentRoute: ActivatedRouteSnapshot,
	_currentState: RouterStateSnapshot,
	nextState: RouterStateSnapshot
) => {
	const need4SteelWizardService = inject(Need4SteelWizardService);
	const millOfferService = inject(MillOfferService);

	if (need4SteelWizardService.getState().isValid	&& nextState.url.includes('need4steel/wizard')) {
		return true;
	}
	millOfferService.resetProductFieldNamesLoaded();
	return need4SteelWizardService.actionExitWizard();
};
